import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import AppBanner from "../AppBanner/AppBanner";

//pages
import Home from "../../pages/Home/Home";
import AboutUs from "../../pages/AboutUs/AboutUs";
import Reports from "../../pages/Reports/Reports";
import Events from "../../pages/Events/Events";
import EventDetails from "../../pages/Events/EventDetails";
import Contacts from "../../pages/Contacts/Contacts";
import Alerts from "../../pages/Alerts/Alerts";
import Advisories from "../../pages/Advisories/Advisories";
import AdvisoryDetails from "../../pages/Advisories/AdvisoryDetails";
import AlertDetails from "../../pages/Alerts/AlertDetails";
import Login from "../../pages/Login/Login";
import AlertManagement from "../../pages/Alerts/AlertManagement";
import ReportManagement from "../../pages/Reports/ReportManagement";
import AdvisoryManagement from "../../pages/Advisories/AdvisoryManagement";
import IncidentManagement from "../../pages/Incidents/IncidentManagement";
import UserManagement from "../../pages/Users/UserManagement";
import EventManagement from "../../pages/Events/EventManagement";
import NotFound from "../../pages/NotFound/NotFound";
import { hasAccess } from "../../app/utils";

const AppRoutes = () => {
  const location = useLocation();

  //builders
  const CustomLayout = ({
    component: Component,
    banner = null,
    isPrivate = false,
  }) => {
    return (
      <>
        <Header />
        <div className="page-content">
          {banner && <AppBanner banner={banner} />}
          <Component />
        </div>
        <Footer />
      </>
    );
  };

  const LoginLayout = ({ component: Component }) => {
    return (
      <>
        <Component />
        {/* <Footer /> */}
      </>
    );
  };

  const PrivateRoute = ({ path, element }) => {
    if (!hasAccess("PRIVATE_PAGES")) {
      return (
        <Route
          path={path}
          element={<Navigate to={"/not-found"} state={{ from: location }} />}
        />
      );
    }
    return <Route path={path} element={element} />;
  };

  return (
    <Routes>
      <Route path={"/home"} element={<CustomLayout component={Home} />} />
      <Route path="/" element={<CustomLayout component={Home} />} />
      <Route
        path="/about"
        element={
          <CustomLayout
            component={AboutUs}
            banner={{
              title: "About Us",
            }}
          />
        }
      />
      <Route
        path="/reports"
        element={
          <CustomLayout
            component={Reports}
            banner={{
              title: "Reports",
              breadCrumbs: [
                {
                  title: "Services",
                  link: "#",
                },
              ],
            }}
          />
        }
      />
      <Route
        path="/events"
        element={
          <CustomLayout
            component={Events}
            banner={{
              title: "Events",
            }}
          />
        }
      />
      <Route
        path="/events/event-details"
        element={
          <CustomLayout
            component={EventDetails}
            banner={{
              title: "Event Details",
              breadCrumbs: [
                {
                  title: "Events",
                  link: "/events",
                },
              ],
            }}
          />
        }
      />
      <Route
        path="/contacts"
        element={
          <CustomLayout
            component={Contacts}
            banner={{
              title: "Contact Us",
            }}
          />
        }
      />
      <Route
        path="/alerts"
        element={
          <CustomLayout
            component={Alerts}
            banner={{
              title: "Alerts",
              breadCrumbs: [
                {
                  title: "Services",
                  link: "#",
                },
              ],
            }}
          />
        }
      />
      <Route
        path="/alerts/alert-details"
        element={
          <CustomLayout
            component={AlertDetails}
            banner={{
              title: "Alert Details",
              breadCrumbs: [
                {
                  title: "Services",
                  link: "#",
                },
                {
                  title: "Alerts",
                  link: "/alerts",
                },
              ],
            }}
          />
        }
      />
      <Route
        path="/advisories"
        element={
          <CustomLayout
            component={Advisories}
            banner={{
              title: "Advisories",
              breadCrumbs: [
                {
                  title: "Services",
                  link: "#",
                },
              ],
            }}
          />
        }
      />
      <Route
        path="advisories/advisory-details"
        element={
          <CustomLayout
            component={AdvisoryDetails}
            banner={{
              title: "Advisory Details",
              breadCrumbs: [
                {
                  title: "Services",
                  link: "#",
                },
                {
                  title: "Advisories",
                  link: "/advisories",
                },
              ],
            }}
          />
        }
      />
      <Route
        path="/not-found"
        element={
          <CustomLayout
            component={NotFound}
            banner={{
              title: "404 - Page Not Found",
            }}
          />
        }
      />
      <Route path="/Login" element={<LoginLayout component={Login} />} />

      {PrivateRoute({
        path: "advisories/advisory-management",
        element: (
          <CustomLayout
            component={AdvisoryManagement}
            banner={{
              title: "Advisory Management",
              breadCrumbs: [
                {
                  title: "Services",
                  link: "#",
                },
                {
                  title: "Advisories",
                  link: "/advisories",
                },
              ],
            }}
          />
        ),
      })}
      {PrivateRoute({
        path: "alerts/alert-management",
        element: (
          <CustomLayout
            component={AlertManagement}
            banner={{
              title: "Alert Management",
              breadCrumbs: [
                {
                  title: "Services",
                  link: "#",
                },
                {
                  title: "Alerts",
                  link: "/alerts",
                },
              ],
            }}
          />
        ),
      })}
      {PrivateRoute({
        path: "reports/report-management",
        element: (
          <CustomLayout
            component={ReportManagement}
            banner={{
              title: "Report Management",
              breadCrumbs: [
                {
                  title: "Services",
                  link: "#",
                },
                {
                  title: "Reports",
                  link: "/reports",
                },
              ],
            }}
          />
        ),
      })}

      {PrivateRoute({
        path: "/incident-management",
        element: (
          <CustomLayout
            component={IncidentManagement}
            banner={{
              title: "Incident Management",
            }}
          />
        ),
      })}
      {PrivateRoute({
        path: "/events/event-management",
        element: (
          <CustomLayout
            component={EventManagement}
            banner={{
              title: "Event Management",
            }}
          />
        ),
      })}

      {PrivateRoute({
        path: "/user-management",
        element: (
          <CustomLayout
            component={UserManagement}
            banner={{
              title: "User Management",
            }}
          />
        ),
      })}

      <Route
        path="*"
        element={
          <CustomLayout
            component={NotFound}
            banner={{
              title: "404 - Page Not Found",
            }}
          />
        }
      />
    </Routes>
  );
};

export default AppRoutes;
